export default {
  namespaced: true,
  state: () => ({
    applications: {
      new: [],
      in_review: [],
      deffered: [],
      approved_pending: [],
      approved: [],
      expired: [],
      declined: [],
      contract_signed: [],
      completed: [],
    },
  }),
  mutations: {
    SET_APPLICATIONS(state, applications) {
      [
        "new",
        "in_review",
        "deffered",
        "approved_pending",
        "approved",
        "expired",
        "declined",
        "contract_signed",
        "completed",
      ].forEach((status) => {
        if (applications[status].length > 0) {
          state.applications[status] = applications[status];
        }
      });
      state.applications = applications;
    },
  },
  actions: {
    get({ commit }) {
      fetch("http://localhost:90/applications")
        .then((result) => {
          return result.json();
        })
        .then((result) => {
          return result;
        });
      console.log("commit:", commit);
    },
  },
};
